import { useEffect, useState } from 'react';
import CNLogo from '../../../components/CNLogo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowCircleLeft,
  faCertificate,
  faTrophy,
} from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { CircularProgressbar, buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import {
  getCertificate,
  unlockCertificate,
  getCertificateLink,
} from '../../../redux/actions/certificate';
import { userActivity } from '../../../common/constants';
import Gamification from '../../../components/Gamification';
import { useGamification } from '../../../context/GamificationContext';
import { getChallengeInfo } from '../../../redux/actions/quiz';
import { Mixpanel } from '../../../config/Mixpanel';
import Constants from '../../../common/constants';
import { downloadCertificate, generateCertificate } from '../../../utils/generateCertificate';
import certificate from './assets/certificate.png';
import { IKImage } from 'imagekitio-react';
import CertificatePreview from './CertificatePreview';
import ExitPopUp from './ExitPopUp';

export default function ContentPlayerNavbar({
  playerDetails,
  progress,
  mskill_slug,
  quizRef,
  mskillProgressObject,
  skillProgress
}) {
  const user_name = useSelector((store) => store?.profileDetails?.name);
  const user_token = useSelector((store) => store?.authentication?.user_token);
  const email = useSelector((store) => store?.profileDetails?.email);
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const dispatch = useDispatch();
  const { setOpenConfirmationModal, setType } = useGamification();
  const navigate = useNavigate();
  const { contentId } = useParams();
  const [challengeInfo, setChallengeInfo] = useState(null);
  const user_coin = useSelector(store => store?.userActivity?.user_coins?.['available-coins']);
  const is_activation = useSelector(store => store?.userActivity?.is_activation)
  const [isPreview , setIsPreview ] = useState(false);
  const [isExitPopUp , setIsExitPopUp] = useState(false);

  useEffect(() => {
    if (progress === 100) {
      dispatch(
        getChallengeInfo(user_id, mskill_slug, (successObj) => {
          setChallengeInfo(successObj[0]);
        })
      );
      dispatch(getCertificate(user_id, mskill_slug));
    }

    return () => {
      setChallengeInfo(null);
    };
  }, [progress, contentId]);

  function certificateDownloadHandler() {
    if (user_token) {
      dispatch(
        getCertificate(user_id, mskill_slug, async (data) => {
          if (data?.certificate_unlock_status === 'locked') {
            await dispatch(unlockCertificate(user_id, mskill_slug));
            // Trigger Img download
            dispatch(
              getCertificateLink(data.unique_certificate_id, (link) => {
                downloadCertificate(link);
              })
            );
          } else {
            // Trigger Img download
            dispatch(
              getCertificateLink(data.unique_certificate_id, (link) => {
                downloadCertificate(link);
              })
            );
          }
        })
      );
    } else navigate('/login');
  }

  return (
    <>
      <div className="bg-white flex justify-between items-center py-1 shadow-lg px-2 md:px-8" onMouseMove={(e)=>{ 
        if( e.clientX<= window.innerWidth*0.9 && e.clientY <= 30){
          setIsExitPopUp(true)
        }
        else{
          setIsExitPopUp(false)
        }
    }  } >
        {<Link
          to={`/${playerDetails?.['course_slug']}/${playerDetails?.['skill_slug']}`}
          style={{pointerEvents: is_activation ? "none" : "auto"  }}
        >
          {!is_activation ? <div className="top-3 text-xs md:text-sm font-bold justify-between items-center border-2 cursor-pointer border-slate-800 rounded py-2 px-2 bg-white hover:bg-zinc-50 hover:text-black left-3 md:left-10 flex">
            <FontAwesomeIcon
              icon={faArrowCircleLeft}
              className="text-lg md:text-base"
            />
            <p className="ml-2 hidden md:block">Back To Course</p>
          </div> : <div className='ml-10'></div>}
        </Link>}
        {!is_activation ? <div className="flex justify-center items-center scale-90 x-4" >
          <a href="/">
          <div className={`w-fit bg-white flex items-center  rounded-md p-2 ml-1 md:ml-0 md:p-2 gap-2`}>
                                  <img src="https://assets.learntube.ai/files/post-payment-updates/image%2011.svg?updatedAt=1728356261811" loading="eager" alt=""  className='h-[31px] w-[31px] md:h-[35px] md:w-[35px]'/>
                                  <p className='text-md font-medium md:text-lg md:flex text-black'>LearnTube.ai</p>
                              </div>
          </a>
        </div>
        : 
       <div className={`w-fit bg-white flex items-center  rounded-md p-2 ml-1 md:ml-0 md:p-2 gap-2`}>
                                  <img src="https://assets.learntube.ai/files/post-payment-updates/image%2011.svg?updatedAt=1728356261811" loading="eager" alt=""  className='h-[31px] w-[31px] md:h-[35px] md:w-[35px]'/>
                                  <p className='text-md font-medium md:text-lg md:flex text-black'>LearnTube.ai</p>
                              </div>
}
        <div className="reactour-coinscertificates flex flex-row md:flex-row justify-between items-center">
          
          {/* <small className="reactour-progress w-10 h-10 font-bold hidden md:block mx-4">
            
          </small> */}
          <div className='flex flex-col justify-center items-center h-10 md:h-12 mt-2 mr-5 cursor-pointer' onClick={()=>{
            navigate('/pricing?type=coin')
          }}>
            <img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src={
                    "https://assets.learntube.ai/files/Content_player/coinImage.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1676614260936"
                  }
                  className=" h-6 w-6 md:"
                  transformation={[
                    {
                      height: "60",
                      width: "60",
                    },
                  ]}
                />
              <div className='text-black font-bold text-xs mt-2 '>{user_coin}</div>
          </div>
          <div>
            <button
              className=" group text-white relative h-10 w-10 md:w-10 md:h-10  font-semibold  flex flex-col justify-center items-center"
              onClick={() => {
                // setOpenConfirmationModal(true);
                // setType(
                //   challengeInfo?.['3day_challenge'] === 'completed'
                //     ? userActivity?.DOWNLOAD_FREE_CERTIFICATE.type
                //     : userActivity?.DOWNLOAD_PAID_CERTIFICATE.type
                // );
                // Mixpanel.track(Constants.Mixpanel.CERTIFICATE_DOWNLOAD_CLICK, {
                //   distinct_id: email,
                // });
                setIsPreview(true);
                console.log('clicking')
              }}
            >
              <CircularProgressbarWithChildren
                value={progress}
                strokeWidth={9}
                styles={buildStyles({
                  pathTransitionDuration: 0.5,
                  // Colors
                  pathColor: `#68DF5B`,
                  textColor: '#000',
                  trailColor: 'rgb(163 163 163)',
                })}>
                {/* <FontAwesomeIcon icon={faCertificate} /> */}
                <img
                    urlEndpoint="https://assets.learntube.ai/files/"
                    src={
                      "https://assets.learntube.ai/files/Content_player/certificate_image.png?ik-sdk-version=javascript-1.4.3&updatedAt=1672151241471"
                    }
                    className=" h-5 w-5 md:h-5 md:w-5"
                    transformation={[
                      {
                        height: "60",
                        width: "60",
                      },
                    ]}
                />
              </CircularProgressbarWithChildren>
              {/* {progress !== 100 && (
                <div className="invisible group-hover:visible text-slate-500 text-xs absolute top-12 w-60 ">
                  Complete Quiz to
                  <br /> Unlock Certificate
                </div>
              )} */}
            </button>
            <p className="text-xs text-black font-bold">
              {user_name ? user_name?.split(" ")?.[0] : 'User'}
            </p>
          </div>
        </div>
      </div>
      {
      isPreview && <CertificatePreview isModalEnabled={isPreview} setIsModalEnabled={setIsPreview} mskillProgressObject={mskillProgressObject}
      skillProgress={skillProgress}/>
     }
     {is_activation && <ExitPopUp isModalEnabled={isExitPopUp} setIsModalEnabled={setIsExitPopUp} quizRef={quizRef}/>}
    </>
  );
}
